import { useEffect } from 'react';

export const useEventListener = (
    target: Window | Document | HTMLElement | undefined,
    event: keyof DocumentEventMap,
    listener: EventListener,
) => {
    useEffect(() => {
        if (!target) return;
        target.addEventListener(event, listener);
        return () => target.removeEventListener(event, listener);
    }, [event, listener, target]);
};
